import { CommonModule } from '@angular/common'
import { ChangeDetectionStrategy, Component, EventEmitter, Output, model } from '@angular/core'
import { IconComponent, LoaderComponent } from '@ftr/foundation'
import { SignalledInputs } from '../../util/signalled-inputs'

export interface InlineError<T> {
  errorMessage: string
  showRetry: boolean
  showUndo: boolean
  fields?: (keyof T)[]
}

export type InlineSaveStatus<T> = 'loaded' | 'saved' | 'saving' | InlineError<T>

export interface InlineSaveStatusArgs<T> {
  state: InlineSaveStatus<T>
}

@Component({
  selector: 'ftr-inline-save-status',
  templateUrl: './inline-save-status.component.html',
  styleUrl: './inline-save-status.component.css',
  standalone: true,
  imports: [CommonModule, IconComponent, LoaderComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class InlineSaveStatusComponent<T> implements SignalledInputs<InlineSaveStatusArgs<T>> {
  state = model.required<InlineSaveStatus<T>>()
  @Output() retry = new EventEmitter<void>()
  @Output() undo = new EventEmitter<void>()

  /**
   * Allows for type narrowing of the state value, as signals are a function call, which will not type narrow in control flow branches
   */
  protected get stateValue(): InlineSaveStatus<T> {
    return this.state()
  }
}
